import React from 'react';

import { Text } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';

import {
  formatDate,
  formatDistanceToNow,
} from 'src/components/pipelines/utils';

type Props = {
  date: string;
  className?: string;
};

const DeploymentDate = ({ date, className }: Props) => {
  return (
    <div className={className}>
      <Tooltip content={formatDate(date)} position="bottom">
        <Text size="UNSAFE_small" color="color.text.subtlest" weight="semibold">
          {formatDistanceToNow(date, 'date-us-short')}
        </Text>
      </Tooltip>
    </div>
  );
};

export default React.memo(DeploymentDate);
